import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Drop-in replacement for <button className="btn …">.
 * If the onClick handler returns a promise, the button automatically shows a
 * spinner and disables itself until the promise settles — so every click that
 * triggers async work gives immediate "it's working" feedback.
 * You can also force the state with the `loading` prop.
 */
export default function Button({ onClick, loading, disabled, children, className = 'btn', ...rest }) {
  const [busy, setBusy] = useState(false);
  const isLoading = busy || loading;

  const handle = async (e) => {
    if (isLoading || disabled || !onClick) return onClick && onClick(e);
    let result;
    try {
      result = onClick(e);
    } catch (err) {
      throw err;
    }
    if (result && typeof result.then === 'function') {
      setBusy(true);
      try { await result; }
      finally { setBusy(false); }
    }
  };

  return (
    <button
      {...rest}
      className={className + (isLoading ? ' is-loading' : '')}
      disabled={disabled || isLoading}
      onClick={handle}
    >
      {isLoading && <Loader2 size={14} className="btn-spin" />}
      {children}
    </button>
  );
}
